<script>
	export let width = '200px';
	export let height = '200px';

	let style = `width: ${width}; height: ${height}`;
</script>

<style>
	div {
		display: inline-block;
		margin: 0 auto;
	}
</style>

<div {style}>
	<svg width="100%" height="100%" viewBox="0 0 550 550" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;">
    <g id="Artboard1" transform="matrix(1,0,0,1,75,11.5)">
        <rect x="0" y="0" width="400" height="527" style="fill:none;"/>
    </g>
    <g id="T" transform="matrix(1,0,0,1,75,11.5)">
        <rect id="OuterBeamLeftBlack" x="154.494" y="29.228" width="0.527" height="461.772" style="fill:none;stroke:rgb(250,250,250);stroke-width:15px;"/>
        <rect id="OuterBeamRightBlack" x="245.572" y="29.228" width="0.527" height="461.772" style="fill:none;stroke:rgb(250,250,250);stroke-width:15px;"/>
        <path id="Halft2" d="M354.638,118.356L354.638,117.904L248.121,118.081L248.121,118.532L354.638,118.356Z" style="fill:none;stroke:rgb(250,250,250);stroke-width:15px;"/>
        <path id="Halft1" d="M153.638,117.424L153.638,117.974L42.121,118.012L42.121,117.462L153.638,117.424Z" style="fill:none;stroke:rgb(250,250,250);stroke-width:15px;"/>
        <path id="UpperBeamBlack" d="M372.85,44.441L372.849,44.214L28.269,44.331L28.269,44.559L372.85,44.441Z" style="fill:none;stroke:rgb(250,250,250);stroke-width:15px;"/>
        <path id="UpperBeamBlue" d="M367.625,81.311L367.626,80.009L28.269,79.904L28.268,81.207L367.625,81.311Z" style="fill:rgb(23,57,130);stroke:rgb(105,183,255);stroke-width:26px;"/>
        <rect id="InnerBeamBlue" x="200.319" y="45.075" width="0.527" height="427.47" style="fill:none;stroke:rgb(105,183,255);stroke-width:25px;"/>
    </g>
</svg>
</div>